import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageProjects } from "@components/modules/brands/projects/PageProjects";
import { NavigationBrand } from "@components/widgets/AppSubNav/NavigationBrand";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Brand projects`}
    navigation={<NavigationBrand id={id} variant="panel" />}
  >
    <PageProjects />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/brands/projects")({
  component: RouteComponent,
});
